var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"position"},[_c('img',{attrs:{"src":_vm.position.icon,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.position.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }